import {
	StyledContainer,
	StyledContentContainer,
	StyledSpanContainer,
} from './ContentInputRange.styled';

interface IContentInputRangeProps extends React.HTMLAttributes<HTMLDivElement> {
	range: [number, number];
}

const ContentInputRange: React.FC<IContentInputRangeProps> = ({
	range,
	children,
}) => {
	const [min, max] = range;
	return (
		<StyledContainer>
			<StyledSpanContainer>
				<span>min: {min}</span>
				<span>max: {max}</span>
			</StyledSpanContainer>
			<StyledContentContainer>{children}</StyledContentContainer>
		</StyledContainer>
	);
};

export { ContentInputRange };
